// extracted by mini-css-extract-plugin
export default {"status":"index_status__Mqr49","ready":"index_ready__WzAAj","playing":"index_playing__VTk+I","paused":"index_paused__QaVAt","blink":"index_blink__tBIne"};